import { render, staticRenderFns } from "./IntegrationLogButton.vue?vue&type=template&id=72386e6c"
import script from "./IntegrationLogButton.vue?vue&type=script&lang=js"
export * from "./IntegrationLogButton.vue?vue&type=script&lang=js"
import style0 from "./IntegrationLogButton.vue?vue&type=style&index=0&id=72386e6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports